document.addEventListener('turbolinks:load', () => {
  const blurredImageContainers = document.querySelectorAll('.js-clone-image')
  if (blurredImageContainers) {
    blurredImageContainers.forEach((container) => {
      const image = container.nextElementSibling
      container.appendChild(image.cloneNode(true))
    })
  }
})
